import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {IPowerSearchState} from "../reducer/power-search.reducer";


export const getPowerSearchState = createFeatureSelector<IPowerSearchState>(
  'power-search'
);

export const getPowerSearchDashboardConfig = createSelector(
  getPowerSearchState,
  (state: IPowerSearchState) => {
    if(state){
      return state.powerSearchDashboardConfig;
    }
  }
);
export const getQuery = createSelector(
  getPowerSearchState,
  (state : IPowerSearchState) => {
    if(state){
      return state.query;
    }
  }
);
export const getReportProjectId = createSelector(
  getPowerSearchState,
  (state : IPowerSearchState) => {
    if(state){
      return state.reportProjectId
    }
  }
)
export const getPowerSearchAnalyticReportDetails = createSelector(
  getPowerSearchState,
  (state : IPowerSearchState) => {
    if(state){
      return state.reportDetails
    }
  }
);
export const getPowerSearchAnalyticReportError = createSelector(
  getPowerSearchState,
  (state : IPowerSearchState) => {
    if(state){
      return state.error;
    }
  }
)
export const getEntityStatus = createSelector(
  getPowerSearchState,
  (state : IPowerSearchState) => {
    if(state){
      return state.hasEntities;
    }
  }
)
